// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const tipoFeedbackFullfilledReducer = makeSetReducer(['tipo_feedback/fullfilled']);